import { type FormEvent, type ReactElement, useState } from 'react';
import { Button, FormField } from '@/shared/ui';
import { useSignIn } from '../model/use-sign-in';
import { SUBMIT_BUTTON_CLASS, UNDERLINE_INPUT_CLASS } from './auth-form-styles';
import { SubmitArrow } from './submit-arrow';

export interface SignInFormProps {
  readonly onSuccess?: () => void;
}

export const SignInForm = ({ onSuccess }: SignInFormProps): ReactElement => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { fieldErrors, formError, isPending, submit } = useSignIn();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();

    if (await submit({ email, password })) {
      onSuccess?.();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6" noValidate>
      <FormField
        label="이메일"
        type="email"
        autoComplete="email"
        isRequired
        className={UNDERLINE_INPUT_CLASS}
        value={email}
        error={fieldErrors.email}
        onChange={(event) => setEmail(event.target.value)}
      />

      <FormField
        label="비밀번호"
        type="password"
        autoComplete="current-password"
        isRequired
        className={UNDERLINE_INPUT_CLASS}
        value={password}
        error={fieldErrors.password}
        onChange={(event) => setPassword(event.target.value)}
      />

      {formError ? (
        <p role="alert" className="text-sm text-destructive">
          {formError}
        </p>
      ) : null}

      <Button type="submit" isLoading={isPending} className={SUBMIT_BUTTON_CLASS}>
        로그인
        <SubmitArrow />
      </Button>
    </form>
  );
};
